export default __webpack_public_path__ + "static/locationmap-section-preview-mobile-4b040c131e18210db77608439a99a9b2.webp";